import { useMemo } from 'react';

import { ia, inRn } from 'lib/helpers/utility';
import { useTableContext } from 'lib/context/TableContext/TableContext';

import { CustomStatusBarCount } from '../CustomStatusBarCount';
import { CustomStatusBarPagination } from '../CustomStatusBarPagination';
import CustomStatusBarAggregationComponent from '../CustomStatusBarAggregationComponent';

export const useTableStatusBar = ({
  count,
  pagination = true,
  statusPanelData,
  hidden = false,
  alwaysShow = false,
  isPageInputDisabled = false,
  CustomCount,
  CustomPagination,
  data
}) => {
  const { limit, page } = useTableContext();
  const isSinglePage = inRn(count) <= inRn(limit) && inRn(page, 1) <= 1;
  const customData = CustomCount || CustomPagination ? data : null;

  return useMemo(() => {
    if (hidden || (!alwaysShow && isSinglePage && !ia(statusPanelData))) return null;

    return {
      statusPanels: [
        {
          statusPanel: CustomCount || CustomStatusBarCount,
          statusPanelParams: CustomCount ? { data: customData } : { count, pagination },
          align: 'left'
        },
        ...(pagination
          ? [
              {
                statusPanel: CustomPagination || CustomStatusBarPagination,
                statusPanelParams: CustomPagination
                  ? { data: customData }
                  : { count, disabled: isPageInputDisabled },
                align: 'right'
              }
            ]
          : []),
        ...(statusPanelData
          ? [
              {
                statusPanel: CustomStatusBarAggregationComponent,
                statusPanelParams: { statusPanelData },
                align: 'center'
              }
            ]
          : [])
      ]
    };
  }, [
    hidden,
    alwaysShow,
    isPageInputDisabled,
    isSinglePage,
    count,
    pagination,
    statusPanelData,
    CustomCount,
    CustomPagination,
    customData
  ]);
};
